import {Logo, Scout, Enrichment} from 'whiteLabels/dealsuite/assets/icons';
import LogoFull from 'whiteLabels/dealsuite/assets/images/logo-full.png';
import utilsBasic from 'helpers/utils.basic';

export default function factory (constants) {
  if (!utilsBasic.isDefined(constants)) {
    // basics
    return {
      name: 'Scout.1.0',
      shortName: 'Scout',
      companyName: 'Dealsuite',
      logo: {
        full: LogoFull,
        logo: Logo
      },
      email: {
        sales: 'sales@dealsuite.com',
        support: 'support@dealsuite.com'
      },
      links: {
        guide: 'https://ventureiq.nl'
      },
      enrichment: {
        icon: Enrichment,
        ventureIqEnrichment: {
          icon: Scout
        }
      },
      assets: 'scout.dealsuite.com'
    };
  } else {
    // override other constants

    return constants;
  }
}
